import { Component, Input, OnInit } from "@angular/core";
import {
  FormControl,
  FormGroup,
  Validators,
  FormBuilder
} from "@angular/forms";
import { ApiService } from "src/app/core/services/api.service";
import { NotificationService } from "src/app/core/services/notification.service";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { ApiConstants } from "src/app/core/constants/api-path.constants";

@Component({
  selector: "app-add-fixed-routing",
  templateUrl: "./add-fixed-routing.component.html",
  styleUrls: ["./add-fixed-routing.component.scss"]
})
export class AddFixedRoutingComponent implements OnInit {

  public _mFormGroup: FormGroup;
  @Input() routingData: any = null;
  public mType = new FormControl("", Validators.required);
  public mRouteName = new FormControl("", Validators.required);
  public mRouteType = new FormControl("", Validators.required);
  public mRouteSearch = new FormControl("", Validators.required);
  public mAreaSearch = new FormControl("");
  public mLandmarkSearch = new FormControl("");
  public mLandmarkType = new FormControl("");

  _mRoutesData: any[] = [];
  shiftTimes: any[];
  _mTempRoutesData: any[] = [];
  _mLandmarksData: any[] = [];
  _mAreasData: any[] = [];
  _mSiteId: any;
  _mCityId: any;
  routeId: any;
  viewFlag: boolean = false;
  mIsEdit = false;

  _mTitle = "Add Fixed Routing";
  _mTypes = [
    { value: "Route" },
    { value: "Area" },
    { value: "Landmark" }
  ];
  _mRouteTypes: any[] = [
    { key: "P", value: "Primary" },
    { key: "C", value: "Combined" },
    { key: "FC", value: "Fully Combined" }
  ];
  _mLandmarkTypes: any[] = [
    { key: "H", value: "Home" },
    { key: "C", value: "Common" }
  ];

  dropdownSettings = {
    singleSelection: false,
    idField: "id",
    textField: "landmark",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 1,
    allowSearchFilter: true
  };

  dropdownSettingsForArea = {
    singleSelection: false,
    idField: "id",
    textField: "area",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 1,
    allowSearchFilter: true
  };

  constructor(
    private fb: FormBuilder,
    private readonly apiService: ApiService,
    private notifyService: NotificationService,
    private ngxLoader: NgxUiLoaderService
  ) {
    this._mFormGroup = this.fb.group({
      type: this.mType,
      routeName: this.mRouteName,
      routeType: this.mRouteType,
      routeSearch: this.mRouteSearch,
      areaSearch: this.mAreaSearch,
      landmarkSearch: this.mLandmarkSearch,
      landmarkType: this.mLandmarkType
    });
  }

  ngOnInit() {
    this._mSiteId = this.routingData?.siteId;
    this._mCityId = this.routingData?.cityId;
    this.mType.setValue(this._mTypes[0].value);
    this.onTypeChange();
  }

  routeSearch(event) {
    let searchValue = event.target.value;
    if (searchValue) {
      this._mRoutesData = this._mTempRoutesData.filter(route =>
        route.routeName.replace(/\s+/g, '').toLowerCase().includes(searchValue.replace(/\s+/g, '').toLowerCase())
      );
    }
  }

  onItemSelect(item: any) {
  }
  onSelectAll(items: any) {
  }

  getAllRoutes() {
    this.apiService.doGetRequestWithResponse(ApiConstants.getroutebysiteidandtype +
      this._mSiteId + '&type=' +
      "All",
      success => {
        if (success.status == 200) {
          this._mRoutesData = success.body;
          this._mTempRoutesData = success.body;
        } else {
          this._mRoutesData = [];
          this._mTempRoutesData = [];
          this.notifyService.showInfo("No data found", null);
        }
      },
      error => {
      }
    );
  }

  routeSearchSubmit(route) {
    this.routeId = route.id;
  }

  getAllLandmarks() {
    this.apiService.doGetRequestWithResponse(ApiConstants.getlandmarksbylocationidandtype +
      this._mCityId + '&type=' +
      this.mLandmarkType.value,
      success => {
        if (success.status == 200) {
          this._mLandmarksData = success.body;
        } else {
          this._mLandmarksData = [];
          this.notifyService.showInfo("No data found", null);
        }
      },
      error => {
      }
    );
  }

  getAllAreas() {
    this.apiService.doGetRequestWithResponse(ApiConstants.getareabylocationid + '?locationid=' +
      this._mCityId,
      success => {
        if (success.status == 200) {
          this._mAreasData = success.body;
        } else {
          this._mAreasData = [];
          this.notifyService.showInfo("No data found", null);
        }
      },
      error => {
      }
    );
  }

  onTypeChange() {
    const type = this.mType.value;
    this._mTitle = `Add ${type}`;
    type === "Area" && (this.getAllRoutes(), this.getAllAreas(), this.mRouteSearch.setValue(""), this.mAreaSearch.setValue(""));
    type === "Landmark" && (this.getAllRoutes(), this.mLandmarkSearch.setValue(""), this.mLandmarkType.setValue(""), this.mRouteSearch.setValue(""));
    type === "Route" && (this.mRouteName.setValue(""), this.mRouteType.setValue(""));
  }

  onClickOfBack() {
    this.viewFlag = true;
    this.mType.setValue(this._mTypes[0].value);
  }

  // onSubmit() {
  //   if (this._mFormGroup.valid) {
  //     if (this.mType.value == "Route") {
  //       let reqData = {
  //         routeName: this.mRouteName.value,
  //         site: {
  //           siteId: this._mSiteId
  //         },
  //         routeType: this.mRouteType.value
  //       };
  //       this.apiService.doPostRequestWithResponse(ApiConstants.addRoute, reqData, success => {
  //         if (success.status == 200) {
  //           this.notifyService.showSuccess("Route added successfully", null);
  //           this.onClickOfBack();
  //         }
  //       },
  //         error => {
  //           this.notifyService.showWarning('Route Name already exists', null);
  //         }
  //       );
  //     } else if (this.mType.value == "Landmark") {
  //       if (this.mLandmarkSearch.value.length > 0) {
  //         this.apiService.doPostRequestWithResponse(ApiConstants.addlandmarkstoroute + '?routeid=' + this.routeId, this.mLandmarkSearch.value, success => {
  //           if (success.status == 200) {
  //             this.notifyService.showSuccess(
  //               "Landmark added successfully",
  //               null
  //             );
  //             this.onClickOfBack();
  //           }
  //         },
  //           error => {
  //             this.notifyService.showWarning('Landmark name already exists', null);
  //           }
  //         );
  //       } else {
  //         this.notifyService.showWarning("Please select landmark", null);
  //       }

  //     } else if (this.mType.value == "Area") {
  //       if (this.mAreaSearch.value.length > 0) {
  //         this.apiService.doPostRequestWithResponse(ApiConstants.addareastoroute + '?routeid=' + this.routeId, this.mAreaSearch.value, success => {
  //           if (success.status == 200) {
  //             this.notifyService.showSuccess("Area added successfully", null);
  //             this.onClickOfBack();
  //           }
  //         },
  //           error => {
  //             this.notifyService.showWarning('Area name already exists', null);
  //           }
  //         );
  //       } else {
  //         this.notifyService.showWarning("Please select area", null);
  //       }
  //     }
  //   }
  // }

  onSubmit() {
    const type = this.mType.value;
    const isRoute = type === "Route";
    const hasSelection = isRoute || (type === "Landmark" ? this.mLandmarkSearch.value.length : this.mAreaSearch.value.length) > 0;

    if (!hasSelection) {
      this.notifyService.showWarning(`Please select ${type.toLowerCase()}`, null);
      return;
    }

    const data = isRoute
      ? { routeName: this.mRouteName.value, site: { siteId: this._mSiteId }, routeType: this.mRouteType.value }
      : type === "Landmark" ? this.mLandmarkSearch.value : this.mAreaSearch.value;

    const url = isRoute
      ? ApiConstants.addRoute
      : `${type === "Landmark" ? ApiConstants.addlandmarkstoroute : ApiConstants.addareastoroute}?routeid=${this.routeId}`;
    if (
      (type === "Route" && this.mRouteName.value && this.mRouteType.value) ||
      (type === "Area" && this.mRouteSearch.value && this.mAreaSearch.value) ||
      (type === "Landmark" && this.mLandmarkSearch.value && this.mLandmarkType.value && this.mRouteSearch.value)
    ) {
      this.ngxLoader.start();
      this.apiService.doPostRequestWithResponse(
        url,
        data,
        (success) => {
          this.ngxLoader.stop(),
            success.status === 200 && (
              this.notifyService.showSuccess(success.body.message, null),
              this.onClickOfBack()
            )
        },
        (error) => {
          this.ngxLoader.stop(),
            this.notifyService.showWarning(`${type} name already exists`, null)
        }
      );
    }
  }

}
